import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import ProductsPage from "@/pages/products/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import AdminLoginPage from "@/pages/admin/login/page";
import AdminDashboardPage from "@/pages/admin/dashboard/page";
import AdminProductsPage from "@/pages/admin/products/page";
import AdminCategoriesPage from "@/pages/admin/categories/page";
import AdminContactsPage from "@/pages/admin/contacts/page";
import AdminNewsletterPage from "@/pages/admin/newsletter/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin/dashboard", element: <AdminDashboardPage /> },
  { path: "/admin/products", element: <AdminProductsPage /> },
  { path: "/admin/categories", element: <AdminCategoriesPage /> },
  { path: "/admin/contacts", element: <AdminContactsPage /> },
  { path: "/admin/newsletter", element: <AdminNewsletterPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
